import { c as _c } from "react/compiler-runtime";
import type { ResumoLinhaProps } from '../types';
export const ResumoLinhaEmLinha = t0 => {
  const $ = _c(5);
  const {
    rotulo,
    valor
  } = t0;
  let t1;
  if ($[0] !== valor) {
    t1 = <span className="text-heading-dark text-[13px] font-semibold">{valor}</span>;
    $[0] = valor;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== rotulo || $[3] !== t1) {
    t2 = <div className="text-xs text-neutral-500">{rotulo} · {t1}</div>;
    $[2] = rotulo;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export const ResumoLinhaEntreExtremos = t0 => {
  const $ = _c(7);
  const {
    rotulo,
    valor
  } = t0;
  let t1;
  if ($[0] !== rotulo) {
    t1 = <span className="text-label-muted text-[13px]">{rotulo}</span>;
    $[0] = rotulo;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== valor) {
    t2 = <span className="text-heading-dark text-[13px] font-semibold">{valor}</span>;
    $[2] = valor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex items-center justify-between">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};